export default "__VITE_PUBLIC_ASSET__b30a99cf__"